export enum WorkflowStatus {
    None = 0,
    PendingApproval = 1,
    Rejected = 2,
    Approved = 3
}